<template>
  <div class="h-full rounded-lg flex flex-col gap-2">
    <div id="custom-popup" class="popup">
      <div class="popup-content">
        <p>Are you sure you want to continue?</p>
        <button id="confirm-button">Yes</button>
        <button id="cancel-button">No</button>
      </div>
    </div>

    <div
      class="set_data_container text-[var(--text)] w-full rounded-[10px] flex flex-wrap items-center gap-6 p-2 bg-[var(--fundoForm);] capitalize">
      <div class="flex gap-2">
        <label>Técnico:</label>
        <input :disabled="true" type="text" v-model="model_planeamento.tecnico.nome"
          class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[15rem]" />
      </div>
      <button v-if="user.tipo.nome != 'tecnico'" class="fa-solid fa-pen-to-square text-2xl"
        :style="{ color: '#ff9b05' }" @click="open_dialog_alert('tecnico')"></button>

      <div class="flex gap-2">
        <label>Valor Diário:</label>
        <input :disabled="true" type="text" v-model="model_planeamento.tecnico.valor"
          class="text-black text-nowrap text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[5rem]" />
      </div>

      <div class="flex gap-2">
        <label>Valor Semanal:</label>
        <input :disabled="true" type="text" :value="model_planeamento.tecnico.valor * 5"
          class="text-black text-[10px] text-nowrap border-1 border-[#ccc] p-1 rounded-[5px] w-[5rem]" />
      </div>

      <div class="flex gap-2">
        <label>Valor total da semana:</label>
        <input :disabled="true" type="text" :value="totalWeekValue"
          class="text-black text-[10px] text-nowrap border-1 border-[#ccc] p-1 rounded-[5px] w-[5rem]" />
      </div>

      <div class="flex gap-2 ml-auto">
        <AppButton v-if="user.tipo.nome != 'tecnico'" :padding="'var(--padding_btn)'" v-bind:visibility="true"
          :font_size="12" color="#ff9b05" left_icon="fa-solid fa-pen-to-square" text="Agendar Semana" emitType="select"
          @select="agendar_semana" />
      </div>

    </div>
    <div class="flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema flex-1">
      <AppFilterForm :tabela="tabela" :visibility="show_form_filter" @close="closeFilterForm" />

      <div class=" text-white w-full rounded-[10px] flex items-center gap-6 p-4 bg-[#4646768c] capitalize">
        <AppWeelkyCalendar :isTecnico="isTecnico"  :tecnico="model_planeamento.tecnico" :zona="model_planeamento.zona"
          @refreshTable="refresh = true" :servico="ordemServico" :agendarSemana="agendar"
          @totalWeekValue="setTotalWeekValue" @weekValidated="agendar = false" @servicoCreated="setZona" />
      </div>

      <div v-if="user.tipo.nome != 'tecnico'" class="w-full">
        <AppTablePagination v-if="show_table" :visibility="true" :show="show_table" table_title="Serviços"
          @row-clicked="select_servico"  :urlString="`ordemservico/filter`" :data="filter_data"
          :refresh="refresh" @refreshed="refresh = false" :filterData="filtroData" :order_by="order_by"
          :page_display="5"  :filterBtn="true" @open-filter="show_filter_popup = true" />
      </div>
    </div>
  </div>

  <Dialog v-if="showDialog" :propsData="dialogProps" @close="closeDialog" @returnData="handleReturnData"
    :pagination="true" />

  <OrdemServicoPopUp v-if="show_filter_popup" :data="filter_data" :tecnico="model_planeamento.tecnico"
    @close="show_filter_popup = false" @confirm="set_filtro" />

  <ordemServicoDateTimePopUp v-if="showOSDateTimePopUp" :model_data="OSDateTime_data" @save-data="setOSDateTime"
    @close="closeOSDateTimePopUp" />
</template>

<script>
import axios from "axios";
import { id as loggedID } from "@/extraData";
import AppTable from "@/components/tables/table.vue";
import AppInfoCard from "@/components/infoCard.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppButton from "@/components/updated/button.vue";

import AppForm from "@/components/form.vue";
import AppPlaneamentosForm from "@/components/planeamentoForm.vue";
import AppFilter from "@/components/filter/filter.vue";
import AppActionCard from "@/components/actionCard.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import AppFilterForm from "@/components/filter/filterForm.vue";
import permissionMixin from "@/permissionMixin.js";

import Dialog from "@/components/dialog/dinamicDialog.vue";

import { toast } from "vue3-toastify";
import AppWeelkyCalendar from "@/components/calendario/semanaCalendario.vue";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import OrdemServicoPopUp from "@/components/popUps/ordemServicoPopUp.vue";

import ordemServicoDateTimePopUp from "@/components/popUps/ordemServicoDateTime.vue";

export default {
  mixins: [permissionMixin],
  name: "appPlaneamento",
  components: {
    AppTable,
    AppInfoCard,
    AppForm,
    AppFilter,
    AppActionCard,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppPlaneamentosForm,
    AppButton,
    AppFilterForm,
    AppWeelkyCalendar,
    Dialog,
    AppTablePagination,
    OrdemServicoPopUp,
    ordemServicoDateTimePopUp,
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,

      loggedID: loggedID,

      refresh: false,

      showDialog: false,
      showCrudPopUp: false,
      showOSDateTimePopUp: false,
      show_filter_popup: false,
      isSelectServicoLoading: false,
      currentType: null,

      dialogProps: {
        entity: ["equipamento", "tpiva", "tpmoeda"],
        sideBar: true,
        multi: false,
        queryParams: { equipamento: "custom=1&tpmarca_id=1" },
      },

      currentType: "",

      model_planeamento: {
        tecnico: { id: 0, nome: "", valor: 0 },
        zona: { id: 0, nome: "" },
      },

      ordemServico: {},

      edit_mode: false,
      isTecnico: false,
      active_state: [
        "ativo",
        "pedido",
        "proposta",
        "orcamento",
        "validacao",
        "encomenda",
        "armazem",
      ],

      Servicos_day: {
        monday: [
          { id: 0, nome: "Servico 1", hora: "08:00" },
          { id: 1, nome: "Servico 2", hora: "10:00" },
          { id: 2, nome: "Servico 3", hora: "12:00" },
          { id: 3, nome: "Servico 4", hora: "14:00" },
          { id: 4, nome: "Servico 5", hora: "16:00" },
          { id: 5, nome: "Servico 6", hora: "18:00" },
          { id: 6, nome: "Servico 7", hora: "20:00" },
          { id: 7, nome: "Servico 8", hora: "22:00" },
        ],
        tuesday: [
          { id: 0, nome: "Servico 1", hora: "08:00" },
          { id: 1, nome: "Servico 2", hora: "10:00" },
        ],
        wednesday: [
          { id: 0, nome: "Servico 1", hora: "08:00" },
          { id: 1, nome: "Servico 2", hora: "10:00" },
        ],
        thursday: [
          { id: 0, nome: "Servico 1", hora: "08:00" },
          { id: 1, nome: "Servico 2", hora: "10:00" },
        ],
        friday: [
          { id: 0, nome: "Servico 1", hora: "08:00" },
          { id: 1, nome: "Servico 2", hora: "10:00" },
        ],
        saturday: [
          { id: 0, nome: "Servico 1", hora: "08:00" },
          { id: 1, nome: "Servico 2", hora: "10:00" },
        ],
        sunday: [
          { id: 0, nome: "Servico 1", hora: "08:00" },
          { id: 1, nome: "Servico 2", hora: "10:00" },
        ],
      },

      all_servicos: [
        { id: 0, nome: "Servico 1", hora: "08:00" },
        { id: 1, nome: "Servico 2", hora: "10:00" },
        { id: 2, nome: "Servico 3", hora: "12:00" },
        { id: 3, nome: "Servico 4", hora: "14:00" },
        { id: 4, nome: "Servico 5", hora: "16:00" },
        { id: 5, nome: "Servico 6", hora: "18:00" },
        { id: 6, nome: "Servico 7", hora: "20:00" },
        { id: 7, nome: "Servico 8", hora: "22:00" },
      ],

      //   FilterForm data
      filtroData: {},
      show_form_filter: false,
      selectedFiltro: "",
      filtroOptions: [],
      tabela: "planeamento",
      table_title: "planeamento",

      show_table: true,
      zonas: [],
      servicos: [],

      planeamento: {},

      totalWeekValue: 0,
      agendar: false,

      user: { id: 0, nome: "", tipo: { nome: "" } },
      filter_data: {},
      OSDateTime_data: {
        inicio: "",
        fim: "",
        ordemServico: {},
      },
    };
  },
  async created() {
    //this.getTypes()
    const user = JSON.parse(localStorage.getItem("user"));
    console.log("user:", user);
    this.user = await this.select(
      `${this.baseURl}/api/v1/utilizador/${user.id}/`
    );
    console.log("user:", this.user);

    if (this.user.tipo.nome == "tecnico") {
      this.isTecnico = true;
      this.model_planeamento.tecnico = {
        id: this.user.id,
        nome: this.user.user,
        valor: this.user.objetivoDiario,
      };
      console.log("Tecnico:", this.isTecnico);
    } else {
      this.isTecnico = false;
    }

    if (this.$route.query.ordemServico) {
      //this.ordemServico = JSON.parse(JSON.stringify(this.$route.query.ordemServico));
      const tecnico = JSON.parse(this.$route.query.tecnico);
      console.log("planeamento Tecnico:", tecnico);
      const ordemServico = JSON.parse(this.$route.query.ordemServico);
      if (tecnico.id != 0)
        this.model_planeamento.tecnico = {
          id: tecnico.id,
          nome: tecnico.user,
          valor: tecnico.objetivoDiario,
        };

      this.ordemServico = ordemServico;
    }

    this.setPlaneamentoForm(null);
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
    },

    close_table() {
      this.show_table = false;
    },

    closeFilterForm() {
      this.show_form_filter = false;
    },
    triggerAction(action) {
      // console.log("action to perform:", action)
      if (action.action === "create_planeamento") {
        this.model_planeamento.tecnico = { id: 0, nome: "" };

        // console.log('Create planeamento');
        // this.create_planeamento_ = true;
        // this.form_title = "Criar planeamento"
        // this.setPlaneamentoForm(null);
        // this.show_form = true;
        // this.close_generic_table();
      }
      if (action.action === "show_table") {
        this.show_table = true;
      }
      if (action.action === "criar_filtro") {
        this.show_form_filter = true;
      }
    },

    async get_planeamentos() {
      this.refresh = true;
    },

    async select_servico(data) {
      if (this.isSelectServicoLoading) return; // Prevent multiple clicks

      this.isSelectServicoLoading = true; // Lock the method

      // if(data.status =='pendente'){
      //       toast("A Encomenda Precisa da aprovação financeira!", {
      //         theme: "auto",
      //         type: "warning",
      //         position: "top-center",
      //         autoClose: 1000,
      //       });
      //       this.isSelectServicoLoading = false; // Release the lock
      //       return;
      // }
      try {
        if (this.model_planeamento.tecnico.id == 0) {
          toast("Escolha um Técnico!", {
            theme: "auto",
            type: "warning",
            position: "top-center",
            autoClose: 1000,
          });
          this.isSelectServicoLoading = false; // Release the lock
          return;
        }

        const ordemservico = await this.select(
          `${this.baseURl}/api/v1/ordemservico/${data.id}/`
        );
        if (ordemservico) {
          const ordemFetched = JSON.parse(JSON.stringify(ordemservico.data));
          if(ordemFetched.status == 'pendente'){
            toast("A Encomenda Precisa da aprovação financeira!", {
              theme: "auto",
              type: "warning",
              position: "top-center",
              autoClose: 1000,
            });
            this.isSelectServicoLoading = false; // Release the lock
            return;
          }
          this.OSDateTime_data.inicio = ordemFetched.data_inicio;
          this.OSDateTime_data.fim = ordemFetched.data_fim;
          this.OSDateTime_data.ordemServico = ordemFetched;

          if (
            ordemFetched.status == "ativo" ||
            ordemFetched.status == "remarcar"
          ) {
            this.showOSDateTimePopUp = true;
          }
          else{
            this.ordemServico = JSON.parse(
              JSON.stringify(ordemFetched)
            );
            this.showOSDateTimePopUp = false;
            this.isSelectServicoLoading = false; // Release the lock

          }
          
        }
      } catch (error) {
        console.error("Error in select_servico:", error);
      } finally {
        // Unlock the method
      }
    },

    async setOSDateTime(data) {
      try {
        const res = await this.update(`${this.baseURl}/api/v1/ordemservico/editar/${data.ordemServico.id}/`, {
          data_inicio: data.inicio,
          data_fim: data.fim
        });

        if (res) {
          const ordemFetched = await this.select(`${this.baseURl}/api/v1/ordemservico/${data.ordemServico.id}/`);
          this.ordemServico = JSON.parse(JSON.stringify(ordemFetched.data));
          this.showOSDateTimePopUp = false;
          this.refresh = true;
        }
      } catch (error) {
        console.error("Error in setOSDateTime:", error);
      } finally {
        this.isSelectServicoLoading = false; // Release the lock
      }
    },

    closeOSDateTimePopUp() {

      this.showOSDateTimePopUp = false;
      this.isSelectServicoLoading = false; // Release the lock
      
    },


    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return res.data.data;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },
    async getTypes() {
      const zonas = await this.select(`${this.baseURl}/api/v1/tpzona/`);
      const servicos = await this.select(`${this.baseURl}/api/v1/servico/`);
      this.zonas = zonas?.sort((a, b) => a.id - b.id);
      this.servicos = servicos?.sort((a, b) => a.id - b.id);
    },

    setPlaneamentoForm(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      this.planeament_formData = {
        id: data && data.id ? data.id : 0,
        planeamento: data && data.nome ? data.nome : "",
        codigo_barras: data && data.codigo_barras ? data.codigo_barras : "",
        descricao: data && data.descricao ? data.descricao : "",
      };

      this.planeamento_setData = {
        tipo_artigo:
          data && data.tipo_artigo && !isEmptyObject(data?.tipo_artigo)
            ? data.tipo_artigo
            : { id: 0, nome: "Não Atribuido" },
        armazem:
          data && data.armazem && !isEmptyObject(data?.armazem)
            ? data.armazem
            : { id: 0, nome: "Não Atribuido" },
        cliente:
          data && data.cliente && !isEmptyObject(data?.cliente)
            ? data.cliente
            : { id: 0, nome: "Não Atribuido" },
        sub_cliente:
          data && data.sub_cliente && !isEmptyObject(data?.sub_cliente)
            ? data.sub_cliente
            : { id: 0, nome: "Não Atribuido" },
        equipamento:
          data && data.equipamento && !isEmptyObject(data?.equipamento)
            ? data.equipamento
            : { id: 0, nome: "Não Atribuido" },
        servico:
          data && data.servico && !isEmptyObject(data?.servico)
            ? data.servico
            : { id: 0, nome: "Não Atribuido" },
        local:
          data && data.local && !isEmptyObject(data?.local)
            ? data.local
            : { id: 0, nome: "Não Atribuido" },
      };
    },

    setData(data) {
      let prepared_data = {
        artigo: data.artigo || "",
        codigo_barras: data.codigo_barras || "",
        armazem_id: data?.armazem?.id || 0,
        cliente_id: data?.cliente?.id || 0,
        subcliente_id: data?.sub_cliente?.id || 0,
        tpArtigo_id: data?.tipo_artigo?.id || 0,
        equipamento_id: data?.equipamento?.id || 0,
        servico_id: data?.servico?.id || 0,
        descricao: data.descricao || "",
        local_id: data?.local?.id || 0,
      };
      return prepared_data;
    },

    show_form_table(data) { },

    open_dialog_alert(key) {
      if (key == "iva") {
        this.dialogProps.entity[0] = "tpiva";
        this.currentType = "tpiva";
        this.showDialog = true;
      } else if (key == "zona") {
        this.dialogProps.entity[0] = "tpzona";
        this.currentType = "tpzona";
        this.showDialog = true;
      } else if (key == "tecnico") {
        this.dialogProps.entity[0] = "tecnico";
        this.currentType = "tecnico";
        this.showDialog = true;
      } else if (key == "servico") {
        this.dialogProps.entity[0] = "servico";
        this.currentType = "servico";
        this.showDialog = true;
      }

      // this.$emit('open_dialog_alert',key)
    },

    handleReturnData(data) {
      console.log("Returned data:", data);

      if (data.tpiva) {
        this.setDataCopy.iva.nome = data.tpiva.nome;
        this.setDataCopy.iva.id = data.tpiva.id;
      } else if (data.tpzona) {
        this.model_planeamento.zona.nome = data.tpzona.nome;
        this.model_planeamento.zona.id = data.tpzona.id;
      } else if (data.precario) {
        this.setDataCopy.tabelaPrecos.nome = data.precario.nome;
        this.setDataCopy.tabelaPrecos.id = data.precario.id;
      } else if (data.servico) {
        this.setDataCopy.servico.nome = data.servico.nome;
        this.setDataCopy.servico.id = data.servico.id;
      } else if (data.tecnico) {
        const isEmptyObject = (obj) =>
          Object.keys(obj).length === 0 && obj.constructor === Object;

        console.log("Tecnico:", data.tecnico);
        this.model_planeamento.tecnico = JSON.parse(
          JSON.stringify({
            id: data.tecnico.id,
            nome: data.tecnico.user,
            valor: data.tecnico.objetivoDiario,
          })
        );
        this.totalWeekValue = 0;

        if (isEmptyObject(this.filter_data)) {
          console.log("filter is empty");
        } else {
          this.filter_data.utilizador = JSON.parse(
            JSON.stringify(data.tecnico)
          );
          this.show_filter_popup = false;
          this.refresh = true;
        }
      }
    },

    async save_planeamento() {
      // console.log("Data to save:", this.model_planeamento);
      // this.edit_mode = false;
    },

    updatePlaneamento(data) {
      this.planeamento = JSON.parse(JSON.stringify(data));
    },

    agendar_semana() {
      if (this.model_planeamento.tecnico.id == 0) {
        toast("Escolha um Técnico!", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return;
      }
      if (this.agendar) {
        return;
      }
      this.agendar = true;
    },

    setTotalWeekValue(value) {
      this.totalWeekValue = value;
    },

    async set_filtro(data) {
      console.log("Filtro:", data);
      this.filter_data = JSON.parse(JSON.stringify(data));
      this.show_filter_popup = false;
      this.refresh = true;
      //const res= await this.create(data, `${this.baseURl}/api/v1/ordemservico/filter/pagination/`);
      //console.log("Res:", res);
    },

    async setZona(servico) {
      console.log("planeamento Serviço:", servico);
      const zona={'id': servico.localInstalacao.tpZona_id, 'nome': 'N/A'}
      //set filter with zona
      this.filter_data.zona = zona;
      this.refresh = true;
      
    },
  },
  watch: {
    async selectedFiltro(newFiltro) {
      if (newFiltro) {
        this.filtroData = { ...newFiltro };
        delete this.filtroData.id;
        delete this.filtroData.status;
        this.show_table = true;
        this.table_title =
          this.filtroData.nome.charAt(0).toUpperCase() +
          this.filtroData.nome.slice(1).toLowerCase();
        const response = await axios.post(
          `${this.baseURl}/api/v1/filtro/testar/`,
          this.filtroData
        );
        this.artigos = response.data.data;
        console.log(this.artigos);
      } else {
        this.get_planeamento();
        this.table_title = "planeamentos";
        this.show_table = true;
      }
    },
  },
};
</script>

<style>
.scroll-style {
  overflow-y: auto;
  scrollbar-color: gray transparent;
  scrollbar-width: thin;
}

.popup {
  position: fixed;
  display: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid black;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.popup-content {
  text-align: center;
}

.popup button {
  margin: 0 10px;
  padding: 5px 10px;
  cursor: pointer;
}

.btn {
  font-size: 12px;
  width: fit-content;
  padding: 0.5rem 0.8rem;
  color: white;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #626288;
}

.btn:hover {
  background-color: #c67700;
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
